/* tslint:disable */
/* eslint-disable */
/**
 * Gestionale.API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ContattoCreateDTO
 */
export interface ContattoCreateDTO {
    /**
     * 
     * @type {number}
     * @memberof ContattoCreateDTO
     */
    idAnagrafe?: number;
    /**
     * 
     * @type {number}
     * @memberof ContattoCreateDTO
     */
    idTipoContatto?: number;
    /**
     * 
     * @type {string}
     * @memberof ContattoCreateDTO
     */
    valore?: string | null;
}

/**
 * Check if a given object implements the ContattoCreateDTO interface.
 */
export function instanceOfContattoCreateDTO(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function ContattoCreateDTOFromJSON(json: any): ContattoCreateDTO {
    return ContattoCreateDTOFromJSONTyped(json, false);
}

export function ContattoCreateDTOFromJSONTyped(json: any, ignoreDiscriminator: boolean): ContattoCreateDTO {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'idAnagrafe': !exists(json, 'idAnagrafe') ? undefined : json['idAnagrafe'],
        'idTipoContatto': !exists(json, 'idTipoContatto') ? undefined : json['idTipoContatto'],
        'valore': !exists(json, 'valore') ? undefined : json['valore'],
    };
}

export function ContattoCreateDTOToJSON(value?: ContattoCreateDTO | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'idAnagrafe': value.idAnagrafe,
        'idTipoContatto': value.idTipoContatto,
        'valore': value.valore,
    };
}

